import { configureStore } from '@reduxjs/toolkit';
import userSlice from './feature/user';

export const store = configureStore({
  reducer: {
      user:userSlice
  },
})